import React, { Component } from "react";
import "./MText.css";

class MText extends Component {
  render() {
    return (
      <div id="mText">
        <p className="mTextText">Skyward Therapies practices what is referred to as Medical Massage Therapy. Which is characterized by using any technique and or therapy that is needed to best help address your individual needs.</p>
        <p className="mTextText">Aromatherapy, Micro-Vibrational Therapy, Hot Stones, and or Cold therapies are always included.</p>
      </div>
    );
  }
}

export default MText;
